export default __webpack_public_path__ + "static/media/k1.686a7279.svg";